import { Box, Modal } from '@mui/material'

import { SlideType } from '../../../_types'
import { GridSlideSelector } from '../SlideSelectors/GridSlideSelector'

export interface ModalGridSlideSelectorProps {
  slides: SlideType[]
  isOpen: boolean
  activeIndex: number
  handleToggle: any
  onSlideSelect: any
}
export const ModalGridSlideSelector: React.FC<ModalGridSlideSelectorProps> = ({
  slides,
  isOpen,
  activeIndex,
  onSlideSelect,
  handleToggle,
}) => {
  return (
    <Modal
      keepMounted
      open={isOpen}
      onClose={handleToggle}
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        width="90%"
        sx={{
          paddingTop: '30px',
          paddingBottom: '30px',
          backgroundColor: '#59595b',
          opacity: 0.9,
          overflowY: 'scroll',
          maxHeight: '90vh',
        }}
      >
        <GridSlideSelector
          slides={slides}
          activeIndex={activeIndex}
          onSlideSelect={onSlideSelect}
        />
      </Box>
    </Modal>
  )
}

export default ModalGridSlideSelector
